import axios from 'axios'
import config from 'config'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import useSnackbar from 'components/organisms/Snackbar/useSnackbar'

const usePartnersGroups = () => {
  const { t } = useTranslation()
  const { showSnackbarMessage } = useSnackbar()

  const [state, setState] = useState({
    isFetching: false,
    groups: [],
    error: null,
  })

  const setStartFetching = useCallback(() => {
    setState((s) => ({
      ...s,
      isFetching: true,
    }))
  }, [setState])

  const setStopFetching = useCallback(
    (error) => {
      setState((s) => ({
        ...s,
        isFetching: false,
        error: error,
      }))
    },
    [setState]
  )

  const setSuccessFetching = useCallback(
    (data) => {
      setState((s) => ({
        ...s,
        isFetching: false,
        ...data,
        error: null,
      }))
    },
    [setState]
  )

  const fetchPartnersGroups = useCallback(
    async (sessionId) => {
      setStartFetching()

      try {
        const results = await axios.get(`${config.apiBaseUrl}partners-groups`)
        setSuccessFetching({ groups: results.data.body })
      } catch (e) {
        let message = t('common.error.fetchData', {
          attribute: e.response?.status,
        })

        setStopFetching(e)

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [
      setStartFetching,
      setStopFetching,
      setSuccessFetching,
      showSnackbarMessage,
      t,
    ]
  )

  return {
    partnersGroups: state.groups,
    isFetching: state.isFetching,
    error: state.error,
    fetchPartnersGroups,
  }
}

export default usePartnersGroups
